import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    dialogPaper: {
      width: '85%',
    },
    formErrorMessage: {
      marginRight: theme.spacing(1),
    },
    btnLeftMargin: {
      marginLeft: '5px',
    },
  };
};
